import { MAIN_ITEM_LOCAL_STORAGE } from '../constants'

const defaultState = {
  token: undefined,
  user: undefined
}

export const state = () => ({
  ...defaultState
})

// getters
const getters = {
  getToken: (actualState) => actualState.token,
  getUser: (actualState) => actualState.user
}

// mutations
const mutations = {
  clearData(actualState) {
    actualState.token = defaultState.token
    actualState.user = defaultState.user
    localStorage.setItem(
      MAIN_ITEM_LOCAL_STORAGE,
      JSON.stringify({ ...actualState })
    )
  },
  setSessionData(actualState, sessionData) {
    actualState.token = sessionData.token
    actualState.user = sessionData.user
    localStorage.setItem(
      MAIN_ITEM_LOCAL_STORAGE,
      JSON.stringify({ ...actualState })
    )
  },
  setUserData(actualState, sessionData) {
    actualState.user = sessionData.user
    localStorage.setItem(
      MAIN_ITEM_LOCAL_STORAGE,
      JSON.stringify({ ...actualState })
    )
  },
  setUserImageProfile(actualState, imageProfileData) {
    if (actualState.user) {
      actualState.user.avatar = imageProfileData
    }
    localStorage.setItem(
      MAIN_ITEM_LOCAL_STORAGE,
      JSON.stringify({ ...actualState })
    )
  },
  setDataFromLocalStorage(actualState, localStorageData) {
    actualState.token = localStorageData.token
    actualState.user = localStorageData.user
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
